export default {
  integrations: [],
  integration: {},
  integrationId: 0,
  isTokenValid: false,
  groups: [],
  whatsappTemplates: []
};
